import { Link } from "react-router-dom";
import { NAV_LINKS, SITE } from "@/config/site";
import { liveCategories } from "@/mocks/lives";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-background-200/70 bg-background-100">
      <div className="w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-radar-line text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                爆料
                <span className="text-primary-500">直播</span>
              </span>
            </div>
            <p className="mt-4 text-[13px] leading-relaxed text-foreground-600">
              {SITE.orgDesc}
              以现场实时画面与直播镜头追踪，记录正在发生的事。
            </p>
            <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-secondary-300/50 bg-secondary-100/40 px-3 py-1.5 font-label text-[11px] text-secondary-700">
              <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-secondary-500" aria-hidden="true" />
              {SITE.onlineSignals}
            </p>
          </div>

          <nav aria-label="页脚导航">
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              <a href="/" className="cursor-pointer transition-colors hover:text-primary-500">
                网站导航
              </a>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-[13px] text-foreground-600 transition-colors hover:text-primary-500"
                  >
                    <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="内容分类">
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              <a href="/live" className="cursor-pointer transition-colors hover:text-primary-500">
                内容分类
              </a>
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {liveCategories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/live?category=${encodeURIComponent(cat.name)}`}
                    className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-[13px] text-foreground-600 transition-colors hover:text-primary-500"
                  >
                    <i className="ri-price-tag-3-line text-foreground-400" aria-hidden="true" />
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              <a href="/faq" className="cursor-pointer transition-colors hover:text-primary-500">
                联系与投稿
              </a>
            </h4>
            <ul className="mt-4 flex flex-col gap-3 text-[13px] text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-500" aria-hidden="true" />
                <span>
                  内容合作
                  <a
                    href={`mailto:${SITE.email}`}
                    className="ml-1 cursor-pointer whitespace-nowrap text-foreground-800 underline decoration-background-400 underline-offset-4 transition-colors hover:text-primary-500"
                  >
                    {SITE.email}
                  </a>
                </span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-send-plane-line mt-0.5 text-primary-500" aria-hidden="true" />
                <span>
                  爆料投稿
                  <a
                    href={`mailto:${SITE.tipEmail}`}
                    className="ml-1 cursor-pointer whitespace-nowrap text-foreground-800 underline decoration-background-400 underline-offset-4 transition-colors hover:text-primary-500"
                  >
                    {SITE.tipEmail}
                  </a>
                </span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-primary-500" aria-hidden="true" />
                <span>{SITE.serviceHours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-300/50 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © {year} {SITE.name} · {SITE.legalName}
          </p>
          <p className="text-xs leading-relaxed text-foreground-500">
            现场画面均标注采集时间，未经核实的说法会明确标识为待确认。
          </p>
        </div>
      </div>
    </footer>
  );
}